<template>
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Filtro</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-autocomplete
                  v-model="filter.fornecedorId"
                  :items="fornecedores"
                  item-text="nomeFantasia"
                  item-value="nomeFantasia"
                  label="Fornecedor"
                  clearable
                  hide-details
                  hide-selected
                  solo
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6" md="6">
                <v-autocomplete
                  v-model="filter.filterdescricaoMaterial"
                  :items="materiais"
                  item-text="descricao"
                  item-value="descricao"
                  label="Material Fornecido"
                  clearable
                  hide-details
                  hide-selected
                  solo
                ></v-autocomplete>
              </v-col>
              
              <hr>
              <v-col cols="12" sm="12" md="12">

                <v-radio-group
                    v-model="filter.order"
                    inline
                >
                
                <template v-slot:label>
                    <div>Ordem Alfabetica</div>
                </template>
                    <v-radio
                        label="Ordernar"
                        value="1"
                    ></v-radio>
                    <v-radio
                        label="Não Ordernar"
                        value="-1"
                    ></v-radio>
                </v-radio-group>
            </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="$emit('close')">
            Cancelar
          </v-btn>
          <v-btn color="red" text @click="clearFilter">
            Limpar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'ModalFilterView',
    props: ['open'],
    data() {
        return {
            filter: {
                fornecedorId: null,
                filterdescricaoMaterial: null,
                order: "1"
            },
            dialog: false,
            fornecedores: [],
            materiais: []
        };
    },
    watch: {
        open(newVal) {
            this.dialog = newVal;

            if(newVal && this.fornecedores.length === 0) {
                this.getFornecedores();
            }

            if(newVal && this.materiais.length === 0) {
                this.getMateriaisFornecedos();
            }
        },

        filter: {
            handler() {
                this.$emit('filter-applied', this.filter)
            },
            deep: true
        }
    },
    methods: {
        async getFornecedores() {
            const response = await Vue.prototype.$http.get('/Entity/Fornecedor/search-fields', {
                params: {
                    page: 1,
                    limit: 3000000
                }
            })
            this.fornecedores = response.data.data.data

        },

        async getMateriaisFornecedos(){
            const response = await Vue.prototype.$http.get('/Entity/FornecedorMateriais/search-fields', {
                params: {
                    page: 1,
                    limit: 3000000
                }
            })

            this.materiais = response.data.data.data
        },

        clearFilter(){
            this.filter = {
                fornecedorId: null,
                filterdescricaoMaterial: null,
                order: "1"
            }
        }
    }
}

</script>